module.exports = __webpack_public_path__ + "static/media/speakers8.7605392d.jpg";